import { DateTimeDataFormat } from 'Lib/Format';
import React from 'react';
import { DateTimeInput, Field, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';

let AsLinearShrinkageCuringSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Curing Time After Mixing">
        <Field
          input={<DateTimeInput />}
          name="Preparation.CuringStartedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field
          input={<DateTimeInput />}
          name="Preparation.CuringCompletedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field input={<TextOutput />} name="Preparation.CuringTime" />
      </ListFieldSection>
    </>
  );
};

AsLinearShrinkageCuringSection = withInjectedProps(AsLinearShrinkageCuringSection);

export { AsLinearShrinkageCuringSection };
export default AsLinearShrinkageCuringSection;
